import { httpClient } from './../httpClient';
import { apiErrorHandler } from './helpers';

const SUBSCRIPTION_ADD_ON_PRODUCT_URI = '/subscriptionAddOnProduct';

export const getHostMonthlyAddOnRecord = (hostId, monthWithYear) =>
  httpClient
    .get(`${SUBSCRIPTION_ADD_ON_PRODUCT_URI}/host/${hostId}/month`, { params: { monthWithYear } })
    .then(response => response)
    .catch(apiErrorHandler);

export const getHostAddOnRecord = hostId =>
  httpClient
    .get(`${SUBSCRIPTION_ADD_ON_PRODUCT_URI}/host/${hostId}`)
    .then(response => response)
    .catch(apiErrorHandler);
